import React, { useEffect } from 'react'
import { getAudioVolume } from '../../utils/CookiesUtils'
import './FreeSpinPanel.css'

const ENTRY_SFX = 'assets/ice-bonus/entrada_gratis.wav' // 1.44s, as free play opens
const LOOP_MUSIC = 'assets/ice-bonus/fundo_jogada_gratis.wav' // 37.5s, under free play

// JOGADA GRÁTIS panel. In free play the machine puts it in the bottom-left
// corner of the footer, over the control buttons (youtube 1IM83irO5s8 at 2:30).
//
// The panel itself is game-img/FreePlay12.png: 13 frames of 444x129, stacked
// down the sheet. Each is the whole panel: frame, cells, 1x 2x 3x 5x and the
// tubs, with the JOGADA GRÁTIS fisherman pulling a fish out of his pail and
// putting it back. Only the counts under the tubs are drawn here.
export const FREE_SPIN_MULTIPLIERS = [1, 2, 3, 5]

// The panel is up exactly while free play runs, so its sound lives with it.
// entrada_gratis plays once when it opens, then fundo_jogada_gratis loops
// underneath until it closes.
function useFreeSpinSound() {
    useEffect(() => {
        const entry = new Audio(ENTRY_SFX)
        const music = new Audio(LOOP_MUSIC)
        entry.volume = music.volume = getAudioVolume()
        music.loop = true

        let gone = false
        const startMusic = () => { if (!gone) music.play().catch(() => { }) }
        entry.addEventListener('ended', startMusic)

        // Browsers refuse audio before the page has been interacted with. If
        // that happens, start on the first tap or key instead of losing it.
        let disarm = () => { }
        entry.play().catch(() => {
            if (gone) return
            const kick = () => {
                disarm()
                if (!gone) entry.play().catch(startMusic)
            }
            window.addEventListener('pointerdown', kick)
            window.addEventListener('keydown', kick)
            disarm = () => {
                window.removeEventListener('pointerdown', kick)
                window.removeEventListener('keydown', kick)
            }
        })

        return () => {
            gone = true
            disarm()
            entry.removeEventListener('ended', startMusic)
            entry.pause()
            music.pause()
        }
    }, [])
}

function FreeSpinPanel({ counts = {} }) {
    useFreeSpinSound()

    return (
        <div
            className='fsp'
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/ice-assets/game-img/FreePlay12.png)` }}
            aria-label='Jogada grátis'
        >
            {FREE_SPIN_MULTIPLIERS.map((m, i) => (
                <span key={m} className={`fsp-count fsp-count-${i}`}>{counts[m] ?? 0}</span>
            ))}
        </div>
    )
}

export default FreeSpinPanel
